import { MenuItemDefinition } from '@neos/core'

export const menuItems: Record<string, MenuItemDefinition> = {
  ConveyerMessage: {
    to: 'ConveyerMessageUI',
  },
  MailMergeMessage: {
    to: 'MailMergeMessageUI',
  },
  NotifierMessage: {
    to: 'NotifierMessageUI',
  }
}